export default "__VITE_ASSET__DEKrK2wz__"